import {
  EXPORT_EXCEL_SELECTIVE_ACTIVE,
  EXPORT_STUDENT_EXCEL_SELECTIVE,
  STUDENT_FILTER_FORM_DATE_TIME_SORT_TYPES, STUDENT_FILTER_FORM_STUDENT_STATUS,
  STUDENT_FILTER_FORM_PAYMENT_METHOD, STUDENT_FILTER_FORM_PAYMENT_STATUS,
  STUDENT_TABLE_THEAD_PAYMENT_FILTER_LIST, STUDENT_FILTER_FORM_PRODUCT_TYPE
} from '../interfaces/_constants'

export const studentInitialState = {
  filter: {
    studentId: {
      value: null,
      activeValue: null
    },
    studentInfo: {
      value: null,
      activeValue: null
    },
    dateTime: {
      activeValue: {
        end: null,
        start: null,
        type: STUDENT_FILTER_FORM_DATE_TIME_SORT_TYPES[0],
        value: null,
      },
      end: null,
      start: null,
      type: STUDENT_FILTER_FORM_DATE_TIME_SORT_TYPES[0],
      trigger: true,
      value: null,
    },
    payment: {
      value: STUDENT_TABLE_THEAD_PAYMENT_FILTER_LIST.map(item => item?.value),
    },
    product: {
      activeValue: [],
      keyword: '',
      list: [],
      listOrigin: [],
      loading: false,
      tab: 'all', // all | checked
      value: [],
    },
    search: {
      value: '',
    },
    paymentMethod: {
      activeValue: null,
      keyword: '',
      list: STUDENT_FILTER_FORM_PAYMENT_METHOD,
      listOrigin: STUDENT_FILTER_FORM_PAYMENT_METHOD,
      value: null,
    },
    principal: {
      activeValue: null,
      keyword: '',
      list: [],
      listOrigin: [],
      value: null,
    },
    student: {
      activeValue: null,
      keyword: '',
      list: [],
      listOrigin: [],
      value: null,
    },
    paymentStatus: {
      activeValue: null,
      keyword: '',
      list: STUDENT_FILTER_FORM_PAYMENT_STATUS,
      listOrigin: STUDENT_FILTER_FORM_PAYMENT_STATUS,
      value: null,
    },
    studentStatus: {
      activeValue: null,
      keyword: '',
      list: STUDENT_FILTER_FORM_STUDENT_STATUS,
      listOrigin: STUDENT_FILTER_FORM_STUDENT_STATUS,
      value: null,
    },
  },
  notifications: {
    list: [],
  },
  table: {
    display: {
      list: [],
      loading: true,
    },
    detail: {
      id: null,
      active: null,
      list: [],
    },
    qrHistory: {
      detail: {
        list: [],
        loading: true,
      },
    },
    orderHistory: {
      detail: {
        list: [],
        loading: true,
      },
      filter: {
        orderId: {
          value: null,
          activeValue: null
        },
        dateTime: {
          activeValue: {
            end: null,
            start: null,
            type: STUDENT_FILTER_FORM_DATE_TIME_SORT_TYPES[0],
            value: null,
          },
          end: null,
          start: null,
          type: STUDENT_FILTER_FORM_DATE_TIME_SORT_TYPES[0],
          trigger: true,
          value: null,
        },
        payment: {
          value: STUDENT_TABLE_THEAD_PAYMENT_FILTER_LIST.map(item => item?.value),
        },
        product: {
          activeValue: [],
          value: [],
        },
        search: {
          value: '',
        },
        paymentMethod: {
          activeValue: null,
          keyword: '',
          list: STUDENT_FILTER_FORM_PAYMENT_METHOD,
          listOrigin: STUDENT_FILTER_FORM_PAYMENT_METHOD,
          value: null,
        },
        paymentStatus: {
          activeValue: null,
          keyword: '',
          list: STUDENT_FILTER_FORM_PAYMENT_STATUS,
          listOrigin: STUDENT_FILTER_FORM_PAYMENT_STATUS,
          value: null,
        },
        productType: {
          activeValue: null,
          keyword: '',
          list: STUDENT_FILTER_FORM_PRODUCT_TYPE,
          listOrigin: STUDENT_FILTER_FORM_PRODUCT_TYPE,
          value: null,
        },
        orderStatus: {
          activeValue: null,
          keyword: '',
          list: STUDENT_FILTER_FORM_STUDENT_STATUS,
          listOrigin: STUDENT_FILTER_FORM_STUDENT_STATUS,
          value: null,
        },
      },
    },
    productTab: {
      filter: {
        search: {
          value: null,
          active: null
        },
        category: {
          list: [],
          listOrigin: [],
          activeValue: null,
          value: null,
          keyword: '',
        },
      },
      table: {
        display: {
          list: [],
          listDefault: [],
          loading: true,
        },
        selected: {
          list: [],
        },
        detail: {
          id: null,
          active: null,
          list: [],
        },
        pagination: {
          active: 0,
          amount: 999,
          total: 0,
          totalItems: 0,
        },
      },
      orderModal: false
    },
    pagination: {
      active: 0,
      amount: 20,
      total: 0,
      totalItems: 0,
    },
    selected: {
      list: [],
    },
  },
  printDetail: {},
  exportExcel: {
    list: EXPORT_STUDENT_EXCEL_SELECTIVE,
    activeList: EXPORT_STUDENT_EXCEL_SELECTIVE,
    selectedList: EXPORT_EXCEL_SELECTIVE_ACTIVE,
    keyword: '',
    hiddenList: EXPORT_STUDENT_EXCEL_SELECTIVE
  },
  formEdit: {
    feeShip: {
      value: '',
      status: true,
      message: ''
    },
    studentName: {
      value: '',
      status: true,
      message: ''
    },
    studentPhone: {
      value: '',
      status: true,
      message: ''
    },
    studentEmail: {
      value: '',
      status: true,
      message: ''
    },
    studentAddress: {
      value: '',
      status: true,
      message: ''
    },
    studentNotes: {
      value: '',
      status: true,
      message: ''
    },
    details: [],
    student: {}
  }
}